import { render, staticRenderFns } from "./BomComposite.vue?vue&type=template&id=4493ce92&scoped=true"
import script from "./BomComposite.vue?vue&type=script&lang=js"
export * from "./BomComposite.vue?vue&type=script&lang=js"
import style0 from "./BomComposite.vue?vue&type=style&index=0&id=4493ce92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493ce92",
  null
  
)

export default component.exports